import PropTypes from "prop-types"
import { map } from "lodash"
import classNames from "classnames"
import { List, ListItem, Grid, ListSubheader } from "@mui/material"
import { COLUMNS } from "../shapes"
import ValueWithTooltip from "../value-with-tooltip"
import GridCell from "../grid-cell"

export default function Total({ row, columns }) {
  return (
    <List>
      <ListSubheader disableSticky className="total-subheader">
        <Grid container sx={{ width: "100%" }}>
          <GridCell className="label" size="grow" />
          {map(columns, ({ id, name }) => <GridCell key={id} size="grow">{name}</GridCell>)}
        </Grid>
      </ListSubheader>
      <ListItem>
        <Grid container sx={{ width: "100%" }}>
          {map(row, (value, index) => <GridCell key={index} className={classNames({ label: index === 0 })} size="grow"><ValueWithTooltip value={value} /></GridCell>)}
        </Grid>
      </ListItem>
    </List>
  )
}

Total.propTypes = {
  row: PropTypes.array.isRequired,
  columns: COLUMNS.isRequired,
}
